var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("Siden finnes ikke")]),_c('ButtonComponent',{staticClass:"mt-1",attrs:{"label":"Til forsiden","tag":"router-link","to":{ name: 'Home' }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }